import * as React from 'react';
import { sortMembersBySortOrderFirst } from '../../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder/index';
import { TYPES } from '../../../../../../utils/flattenTree/utils/consts';
import { isMainEntity } from '../../../../../../utils/flattenTree/utils/extractors';
import { getMdName } from '../../../../../../utils/markdownUtils';
import { toUrlFormat } from '../../../../../../utils/treeVisitors';
import { getName } from '../../../../../../utils/treeVisitors/helpers';
import { sectionPrefix } from '../../../../NavigationMenu/utils';
import { TypeLabel } from '../../../../NewSearchBox/SearchResults/TypeLabel';
import { CustomLink } from '../../../../PageElements/CustomLink';
import { SectionContainer } from '../../../../SectionContainer';
import { IndexPageMemberView } from '../../IndexPageJsView/IndexPageMemberView';
import style from './IndexPageTagList.scss';
import { Text } from '../../../../PageElements/Text';

const withType = (arr, type) => arr.map((member) => ({ ...member, type }));

const fillArrayWithMembers =
  (arrayToFill) =>
  (members = [], type, mapFn) => {
    const _members = mapFn ? members.map(mapFn) : members;
    if (_members) {
      arrayToFill.push(
        ...withType(sortMembersBySortOrderFirst(_members), type),
      );
    }
  };

const generateGuidesUrlFormatIfNeeded = (guide) => ({
  ...guide,
  urlFormat: guide.urlFormat || toUrlFormat(getMdName(guide)),
});

export const extractAllMembersFromNode = ({
  data: {
    guides = [],
    relatedGuides = [],
    operations = [],
    messages = [],
    events = [],
    clientEvents = [],
  },
}) => {
  const members = [];
  const mainEntity = messages.filter(isMainEntity);
  const membersFiller = fillArrayWithMembers(members);

  membersFiller(guides, TYPES.MD);
  membersFiller(relatedGuides, TYPES.MD, generateGuidesUrlFormatIfNeeded);
  membersFiller(guides, TYPES.MD);
  membersFiller(mainEntity, TYPES.MAIN_ENTITY);
  membersFiller(operations, TYPES.OPERATION);
  membersFiller(clientEvents, TYPES.CLIENT_EVENT);
  membersFiller(events, TYPES.WEBHOOK);

  return members;
};

const toTagList = (prefix, hasOneTag) => (tagNode) => {
  const members = extractAllMembersFromNode(tagNode);
  return (
    <SectionContainer
      className={style.tagListMemberViewContainer}
      key={`TAG__INDEX__PAGE__${tagNode.data.name}`}
    >
      <IndexPageMemberView
        dataHook="tag-container"
        members={members}
        prefix={
          hasOneTag ? prefix : sectionPrefix(prefix, tagNode.data.urlFormat)
        }
        title={getName(tagNode.data)}
        nameRenderer={(member, getLink, name) => {
          const type =
            member.type === TYPES.OPERATION
              ? member.docs?.request
              : member.type;
          return (
            <React.Fragment>
              <div className={style.typeContainer}>
                {type && <TypeLabel withBorder={false} type={type} />}
              </div>
              <div className={style.nameMemberContainer}>
                <Text size="small" link weight="normal" tagName="span">
                  <CustomLink to={getLink(member.urlFormat)}>{name}</CustomLink>
                </Text>
              </div>
            </React.Fragment>
          );
        }}
      />
    </SectionContainer>
  );
};

export const IndexPageTagList = ({ tags, prefix, hasOneTag }) => {
  return tags.map(toTagList(prefix, hasOneTag));
};
